<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex
          v-if="permissions.employers == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/Employers')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              الموظفين
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.omolas == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/EmployersOmola')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              العمولات
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.badalat == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/EmployerBadalat')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              البدلات
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.hafez == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/EmployerHafez')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              الحوافز
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.khasm == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/EmployerKhasm')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              الخصومات
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.solfa == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/EmployerSolfa')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              السلف
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- <v-flex v-if="permissions.salary == 1 || user.type == 1"  xs12 sm6 md4>
            <v-card
            @click="$router.push('/EmployerSalary')"
            elevation="20"
                style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
                >
                
                    <v-card-title style="margin:auto;font-size:40px;font-weight: bold;" class="align-center fill-height justify-center"> <img style="width:40px;height:30px;margin:0 10px" src="../../../public/images/color.png" alt="aa"> المرتبات </v-card-title>
                
                </v-card>
            </v-flex> -->

        <v-flex
          v-if="permissions.salary_input == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/SalaryInput')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              المرتبات والحوافز
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.vacancy == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/Vacancy')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              اجازات وغياب
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.attends == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/Attends')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              حضور وانصراف
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.mandob_target == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/MandobTargetInput')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/color.png"
                alt="aa"
              />
              تارجت مندوبين
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
